exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".graph-container[data-v-76140bcb] {\n  height: 300px;\n}\n", ""]);

// exports
